import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function BackButton() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.35rem',
        background: 'none',
        border: 'none',
        color: 'var(--color-muted)',
        fontSize: '0.875rem',
        fontWeight: 600,
        cursor: 'pointer',
        padding: '0.25rem 0',
        marginBottom: '0.75rem',
      }}
    >
      ← Back
    </button>
  );
}
